import { forwardRef } from 'react';
import cx from 'classnames';
import { useDraggableToken } from '.';
import { setRef } from '../../../util/ref-util';
import { Flow } from '../../Layouts/Flow';
import { TokenDragType } from '../../TokenInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const TokenDesignContainer = /*#__PURE__*/forwardRef(function TokenDesignContainer({
  dndProps,
  ...props
}, ref) {
  return dndProps ? /*#__PURE__*/_jsx(DraggableTokenContainer, {
    ...props,
    dndProps: dndProps,
    ref: ref
  }) : /*#__PURE__*/_jsx(Flow, {
    ...props,
    ref: ref
  });
});
const DraggableTokenContainer = /*#__PURE__*/forwardRef(function TokenDesignContainer({
  dndProps,
  ...props
}, ref) {
  const {
    ref: draggableRef,
    style: draggableStyle,
    className: draggableClassName
  } = useDraggableToken({
    ...dndProps,
    allowDrag: true,
    type: TokenDragType
  });
  return /*#__PURE__*/_jsx(Flow, {
    ...props,
    ref: e => {
      setRef(ref, e);
      setRef(draggableRef, e);
    },
    style: {
      ...props.style,
      ...draggableStyle
    },
    className: cx(props.className, draggableClassName)
  });
});
//# sourceMappingURL=TokenDesignContainer.js.map